import { render, staticRenderFns } from "./ProductPartThree.vue?vue&type=template&id=20ba8092&scoped=true&"
import script from "./ProductPartThree.vue?vue&type=script&lang=js&"
export * from "./ProductPartThree.vue?vue&type=script&lang=js&"
import style0 from "./ProductPartThree.vue?vue&type=style&index=0&id=20ba8092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba8092",
  null
  
)

export default component.exports